import Image from "@tiptap/extension-image";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

interface BriefRendererProps {
  content: string;
}

export function BriefRenderer({ content }: BriefRendererProps) {
  const editor = useEditor({
    extensions: [StarterKit, Image],
    content,
    editable: false,
    editorProps: {
      attributes: {
        class: "prose prose-sm dark:prose-invert max-w-none text-text-primary",
      },
    },
  });

  if (!editor) return null;

  return <EditorContent editor={editor} />;
}
